var flickityInstances = [];

$(document).ready(function () {
  $(".featured-collection-tabs .tab").on("click", function (evt) {
    evt.preventDefault();
    $(this).toggleClass("active");
    $(this).siblings().removeClass("active");
    var sel = this.getAttribute("data-toggle-target");
    $(".featured-collection-tabs .tab-content")
      .removeClass("active")
      .filter(sel)
      .addClass("active");
  });

  $(".product-tabs .tab").on("click", function (evt) {
    evt.preventDefault();
    $(this).toggleClass("active");
    $(this).siblings().removeClass("active");
    var sel = this.getAttribute("data-toggle-target");
    $(".product-tabs .tab-content")
      .removeClass("active")
      .filter(sel)
      .addClass("active");
  });

  const flickitySlider1 = new Flickity(".text-with-logos-slider", {
    cellAlign: "center",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    freeScroll: false,
    avoidReflow: true,
    wrapAround: true,
  });
  flickityInstances.push(flickitySlider1);

  const flickitySlider2 = new Flickity(".product-ingredients-slider", {
    cellAlign: "left",
    contain: true,
    prevNextButtons: false,
    pageDots: true,
    freeScroll: false,
    avoidReflow: true,
    wrapAround: true,
  });
  flickityInstances.push(flickitySlider2);

  const flickitySlider3 = new Flickity(".product-list-block_slider", {
    cellAlign: "left",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    freeScroll: false,
    avoidReflow: true,
    wrapAround: true,
  });

   const flickitySlider4 = new Flickity(".custom-video-gallery-slider", {
    cellAlign: "center",
    contain: true,
    prevNextButtons: true,
    pageDots: true,
    freeScroll: false,
    avoidReflow: true,
    wrapAround: true,
  });
  flickityInstances.push(flickitySlider4);

  function customSliderSection() {
  const slider = document.querySelector('.media-with-text__slider');
  if (!slider) return;

  let flickitySlider;
  try {
    flickitySlider = new Flickity(slider, {
      cellAlign: "center",
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      freeScroll: false,
      wrapAround: true,
      adaptiveHeight: true
    });
  } catch (err) {
    console.error("Flickity init failed:", err);
    return;
  }

  const prevBtn = document.querySelector('.mt__nav--prev');
  const nextBtn = document.querySelector('.mt__nav--next');

  if (!prevBtn || !nextBtn) return;

  prevBtn.addEventListener('click', () => {
    if (!flickitySlider) return;
    flickitySlider.previous();
  });

  nextBtn.addEventListener('click', () => {
    if (!flickitySlider) return;
    flickitySlider.next();
  });

  return flickitySlider;
}

customSliderSection();

  $(".site-nav__item").hover(
    function () {
      // Mouse enter
      var itemClass = $(this).attr("class").split(" ")[0]; // Get the first class of the <li>
      $(this)
        .find(".custom-grid.grid__item." + itemClass)
        .addClass("open");
    },
    function () {
      // Mouse leave
      var itemClass = $(this).attr("class").split(" ")[0];
      $(this)
        .find(".custom-grid.grid__item." + itemClass)
        .removeClass("open");
    }
  );

  $(".image-slider-with-text .slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    fade: true,
    asNavFor: ".slider-nav",
    prevArrow: ".custom-arrows .left-arrow",
    nextArrow: ".custom-arrows .right-arrow",
  });

  $(".image-slider-with-text .slider-nav").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: false,
    asNavFor: ".image-slider-with-text .slider-for",
    dots: false,
    arrows: false,
    focusOnSelect: true,
    verticalSwiping: false,
  });

$(".custom-announcement-slider").slick({
  vertical: true,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: true,
  dots: false,

  prevArrow: `
    <button type="button" class="slick-prev pull-left" aria-label="Previous">
      <svg class="slick-arrow-icon" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 6L9 12L15 18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    </button>
  `,

  nextArrow: `
    <button type="button" class="slick-next pull-right" aria-label="Next">
      <svg class="slick-arrow-icon" width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 6L15 12L9 18"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"/>
      </svg>
    </button>
  `,

  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        vertical: false,
        arrows: true,
        dots: false,
        fade: true
      }
    }
  ]
});




  var $stickyAddToCart = $(".sticky-add-to-cart-section");
  var scrollThreshold = 100; // Adjust this value to determine "two to three steps"

  $(window).on("scroll", function () {
    var scrollPosition = $(this).scrollTop();

    if (scrollPosition >= scrollThreshold) {
      $stickyAddToCart.addClass("show-sticky-bar");
    } else {
      $stickyAddToCart.removeClass("show-sticky-bar");
    }
  });

  if (window.outerWidth < 769) {
    $(".text-with-icons__blocks-slider").slick({
      arrows: false, // Common setting for all breakpoints
      dots: true, // Common setting for all breakpoints
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true,
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            centerMode: true,
            slidesToShow: 1,
          },
        },
      ],
    });

    const flickitySlider5 = new Flickity(".text-with-logos-mb-slider", {
      cellAlign: "center",
      contain: true,
      prevNextButtons: false,
      pageDots: true,
      freeScroll: false,
      avoidReflow: true,
      wrapAround: true,
    });
    flickityInstances.push(flickitySlider5);

    const flickitySlider6 = new Flickity(".custom-video-gallery", {
      cellAlign: "center",
      contain: true,
      prevNextButtons: true,
      pageDots: true,
      freeScroll: false,
      avoidReflow: true,
      wrapAround: true,
    });
    flickityInstances.push(flickitySlider6);

    window.addEventListener('load', function () {
      flickitySlider6.resize();
    });


    
  }
});


// // Frequently Boughts section

// let productVariantIds = [];
// let totalPrice = 0;

// function updateMainProductPrice() {
//     const mainProductEl = document.querySelector('.main-product');
//     const selectedVariant = mainProductEl.querySelector('.variant-dropdown').selectedOptions[0];
//     const mainProductPriceEl = mainProductEl.querySelector('.product-info .price');
//     mainProductPriceEl.textContent = selectedVariant.dataset.price;
//     updateProductVariants();
// }

// function updateSuggestedProductPrice(dropdown) {
//     const suggestedProductEl = dropdown.closest('.suggested-product');
//     const selectedVariant = dropdown.selectedOptions[0];
//     const suggestedProductPriceEl = suggestedProductEl.querySelector('.suggested-product-info .price');
//     suggestedProductPriceEl.textContent = selectedVariant.dataset.price;
//     updateProductVariants();
// }

// function updateProductVariants() {
//     productVariantIds = [];
//     totalPrice = 0;

//     const mainProductEl = document.querySelector('.main-product');
//     const mainProductVariantId = mainProductEl.querySelector('.variant-dropdown')?.value || mainProductEl.getAttribute('data-product-variant-id');
//     const mainProductPrice = parseFloat(mainProductEl.querySelector('.product-info .price').textContent.replace(/[^0-9.-]+/g, ""));
    
//     productVariantIds.push(mainProductVariantId);
//     totalPrice += mainProductPrice;

//     document.querySelectorAll('.suggested-product').forEach(productEl => {
//         const suggestedProductVariantId = productEl.querySelector('.variant-dropdown')?.value || productEl.getAttribute('data-product-variant-id');
//         const suggestedProductPrice = parseFloat(productEl.querySelector('.suggested-product-info .price').textContent.replace(/[^0-9.-]+/g, ""));
        
//         productVariantIds.push(suggestedProductVariantId);
//         totalPrice += suggestedProductPrice;
      
//     });
//       document.getElementById('total-price').textContent = '$' + totalPrice.toFixed(2);
//       // Calculate the discounted price
//     const discountPercentage = parseFloat(document.querySelector(".frequently_boughts-info .discounts .value").textContent);
//     const discountAmount = (discountPercentage / 100) * totalPrice;
//     const discountedPrice = totalPrice - discountAmount;
//     document.querySelector(".discounted-Price").textContent = '$' + discountedPrice.toFixed(2);
//     document.getElementById('total-price').textContent = '$' + totalPrice.toFixed(2);
// }

// updateProductVariants();

// document.querySelectorAll('.variant-dropdown')?.forEach(dropdown => {
//     dropdown.addEventListener('change', () => {
//         updateSuggestedProductPrice(dropdown);
//         updateProductVariants();
//     });
// });

// async function addProductsToCart() {
//     for (const variantId of productVariantIds) {
//         const response = await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: variantId, quantity: 1 })
//         });
//     }
// }

// document.querySelector('.add-to-cart-F-B')?.addEventListener('click', async (event) => {
//     event.preventDefault();
//     await addProductsToCart();
//     theme.cart.getCartProductMarkup().then(cartMarkup => {
//         const cartForm = new theme.CartForm(document.getElementById('CartDrawerForm'));
//         cartForm.cartMarkup(cartMarkup);
//     });
//     document.dispatchEvent(new CustomEvent('cart:open'));
// });

// ============================================
// Mobile: Flickity slider – active slide center
// ============================================
function fixFlickityTransform() {
  var isMobile = window.innerWidth <= 768;

  flickityInstances.forEach(function (flkty) {
    if (!flkty) return;

    if (isMobile) {
      flkty.options.draggable = false;
      flkty.options.freeScroll = false;

      function applyCenteredTransform() {
        var sliderElement = flkty.element.querySelector('.flickity-slider');
        var viewport = flkty.element.querySelector('.flickity-viewport');
        var cells = flkty.element.querySelectorAll('.flickity-slider > *');
        var activeIndex = flkty.selectedIndex;

        if (sliderElement && viewport && cells[activeIndex]) {
          var viewportWidth = viewport.offsetWidth;
          var activeCellWidth = cells[activeIndex].offsetWidth;
          var totalWidth = 0;
          for (var i = 0; i < activeIndex; i++) {
            totalWidth += cells[i].offsetWidth;
          }
          var translateX = -(totalWidth + activeCellWidth / 2 - viewportWidth / 2);
          sliderElement.style.transform = 'translateX(' + translateX + 'px)';
        }
      }

      flkty.off('change'); // avoid duplicate listeners on resize
      flkty.on('change', applyCenteredTransform);
      applyCenteredTransform();
    } else {
      flkty.options.draggable = true;
      flkty.options.freeScroll = false;
    }
  });
}

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(fixFlickityTransform, 800);
});
window.addEventListener('load', fixFlickityTransform);
window.addEventListener('resize', function () {
  if (window.innerWidth <= 768) {
    setTimeout(fixFlickityTransform, 300);
  }
});
